import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JwtService } from './jwt.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private coreApiUrl = '';

  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ) {
    this.coreApiUrl = environment.coreapipath;
  }

  private setHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.jwtService.getToken()
    });
  }

  private formatErrors(error: any): Observable<never> {
    return throwError(error);
  }

  get<T>(path: string, searchParams: HttpParams = new HttpParams()): Observable<T> {
    return this.http.get<T>(path, { headers: this.setHeaders(), params: searchParams })
      .pipe(catchError(this.formatErrors));
  }

  put<T>(path: string, body: object = {}): Observable<T> {
    return this.http.put<T>(path, JSON.stringify(body), { headers: this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  post<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.post<T>(path, JSON.stringify(body), { headers: this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(path, { headers: this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }
}
